import { gql } from '@apollo/client';

export const UPSERT_MONITORINGFORM = gql`
  mutation UpsertMonitoringFormEdit($input: UpsertMonitoringFormEditInput!) {
    monitoringForm: upsertMonitoringFormEdit(input: $input) {
      id
      version
      indicators {
        id
        indicator {
          id
        }
        dimensions
      }
    }
  }
`;

export const UPSERT_MONITORINGFORM_CONFIGURE = gql`
  mutation UpsertMonitoringFormConfigure($input: UpsertMonitoringFormConfigureInput!) {
    monitoringForm: upsertMonitoringFormConfigure(input: $input) {
      id
      users {
        id
        user {
          id
        }
      }
      dueDates {
        id
        periodNumber
      }
    }
  }
`;
